import Badge from "../Badge";
import React from "react";

// Types ----

type FeedbackBadgeProps = {
  count?: number | null
  positiveRate?: number | null
}

// Helpers ----

const colourThresholds = [
  {rate: 0.7, colour: '#1d994a'},
  {rate: 0.3, colour: '#bbb22c'},
  {rate: 0.0, colour: '#931414'},
];

function toPercentage(rate?: number): string {
  return (100 * Number(rate)).toFixed(1) + '%';
}

// Component ----

function FeedbackBadge({count, positiveRate}: FeedbackBadgeProps) {

  if (Number(count) < 1 || positiveRate === undefined || positiveRate === null) {
    return (
      <Badge
        text={'None'}
        colour={'#757575'}
        textColour={'#FFFFFF'}
      />
    )
  }

  const title = typeof count === 'number' ? `Feedback left ${count} times` : undefined;
  const colour = colourThresholds.find(({rate}) => positiveRate >= rate)?.colour;

  return (
    <Badge
      text={toPercentage(positiveRate)}
      title={title}
      colour={colour}
      textColour={'#FFFFFF'}
    />
  )
}

// Export ----

export default FeedbackBadge;